import { isPartialDate, sortPartialDate } from 'neuro-utils';
import { smaDiagnoses } from 'Routes/Diagnosis/utils/definitions';
import { defineDocConfig } from './utils';

import type { ClinicalArchive } from '.';

export const smaDocumentTypes = defineDocConfig([
  { name: 'diagnosis' },
  { name: 'medication', subTypes: ['medication', 'adverseEffect'] },
  { name: 'motor', subTypes: ['hine_mm', 'rulm', 'chop_intend', 'hfms_e', 'mwt', 'mfm'], secondaryDocs: ['diagnosis'] }, // History needs diagnosis codes
  { name: 'motorFunctionAndMobilityAid', subTypes: ['motorfunction', 'mobilityAid'] },
  { name: 'nutrition' },
  { name: 'pulmonary', subTypes: ['chestCircumference', 'ventilationAid', 'pulmonary'] },
  { name: 'therapy' },
  { name: 'imaging', subTypes: ['cmap', 'dexa', 'muscleImaging', 'echocardiography', 'scoliosis', 'pelvis', 'mri'] },
  { name: 'clinicalstudy', subTypes: ['fvc', 'enmg', 'nocturnalPolygraphy'] },
  { name: 'examination' },
  { name: 'comorbidity', subTypes: ['comorbidity', 'hospitalization'], secondaryDocs: ['medication'] }, // Form needs medication names
  { name: 'generalhealth' },
  { name: 'background', subTypes: ['background', 'measurement'] },
  { name: 'myService', title: 'titleShort' },
]);

export const smaGraphDocTypes = [
  'diagnosis',
  'medication',
  'adverseEffect',
  'hine_mm',
  'hfms_e',
  'rulm',
  'mfm',
  'mwt',
  'background',
  'measurement',
  'comorbidity',
  'hospitalization',
  'mri',
  'pelvis',
  'scoliosis',
  'muscleImaging',
  'dexa',
  'nutrition',
  'ventilationAid',
  'mobilityAid',
  'therapy',
  'motorfunction',
  'chop_intend',
  'papTherapy',
  'nocturnalPolygraphy',
  'enmg',
  'fvc',
  'cmap',
] satisfies TDocumentType[];

export const smaAlerts: IAlert[] = [
  {
    // Notification to the user if a SMA diagnosis document symptomOnsetDate is before date
    content: 'alerts.sma.symptomOnsetDateAfterDiagnosisDate',
    id: 'smaSymptomOnsetDateAfterDiagnosisDate',
    severity: 'warning',
    popup: true,
    rule: (docs = []) => {
      return docs.some(
        d =>
          d._type === 'diagnosis' &&
          'diagnosis' in d &&
          (smaDiagnoses as string[]).includes(d.diagnosis ?? '') &&
          isPartialDate(d.date) &&
          isPartialDate(d.symptomOnsetDate) &&
          sortPartialDate(d.symptomOnsetDate, d.date) > 0,
      );
    },
  },
];

/** Clinical archive types of SMA platform. */
export const smaClinicalArchiveTypes: readonly ClinicalArchive[] = ['LNEU', 'TOI', 'FYST'] as const;
